import React, { useEffect, useState } from "react";
import { ClipLoader } from "react-spinners";
import axiosClient from "../../api/axios";

export default function BecomePartner() {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axiosClient
      .get("/api/our-partners/settings/")
      .then((r) => setSettings(r.data.data))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <section style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "60vh" }}>
        <ClipLoader color="#0d6efd" size={80} />
      </section>
    );
  }

  if (!settings) return null;

  return (
    <section className="testimonial-section ptb-100">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-8">
            <div className="section-heading text-center mb-5">
              <h2>{settings.become_partner_title}</h2>
            </div>
          </div>
        </div>

        <div className="row justify-content-between align-items-center">
          <div className="col-md-6">
            <div className="section-heading mb-5">
              <h4>
                <span className="ti-stats-up rounded mr-3 icon"></span>
                {settings.part1_title}
              </h4>
              {settings.part1_descriptions.map((desc, i) => (
                <p key={i} className="lead">{desc}</p>
              ))}
            </div>
          </div>
          <div className="col-md-5">
            <h5>
              <span className="ti-star rounded mr-3 icon"></span>
              {settings.part2_title}
            </h5>
            <ul className="lead">
              {settings.part2_options.map((opt, i) => (
                <li key={i}>{opt}</li>
              ))}
            </ul>
            <br />
            <p
              className="lead"
              dangerouslySetInnerHTML={{ __html: settings.part2_description }}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
